const Upload = () => {
	return null;
};

export default Upload;
